module.exports = __webpack_public_path__ + "static/media/model3@2x.8a42e00b.png";